const Folder = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.5 5.5A1.5 1.5 0 0 0 4 7v9a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 16V9a1.5 1.5 0 0 0-1.5-1.5h-6.392a2.5 2.5 0 0 1-2.12-1.175l-.074-.12A1.5 1.5 0 0 0 8.642 5.5zM3 7a2.5 2.5 0 0 1 2.5-2.5h3.142a2.5 2.5 0 0 1 2.12 1.175l.074.12a1.5 1.5 0 0 0 1.272.705H18.5A2.5 2.5 0 0 1 21 9v7a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 16z"
      clipRule="evenodd"
    />
  </>
)
export default Folder
